"use client";

import * as React from 'react';

export function getBaseUiRenderProp(
  asChild: boolean | undefined,
  children: React.ReactNode,
): React.ReactElement | undefined {
  if (!asChild || !React.isValidElement(children)) {
    return undefined;
  }

  return children;
}

export function getBaseUiChildren(
  asChild: boolean | undefined,
  children: React.ReactNode,
): React.ReactNode {
  if (asChild && React.isValidElement(children)) {
    return undefined;
  }

  return children;
}
